var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5DCF71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5127 17.7219L21.0127 10.9062C20.7362 10.6533 20.375 10.513 20.0002 10.513C19.6254 10.513 19.2642 10.6533 18.9877 10.9062L11.4877 17.7219C11.3341 17.8624 11.2115 18.0333 11.1276 18.2237C11.0436 18.4142 11.0003 18.62 11.0002 18.8281V27.4625C10.9941 27.8407 11.1276 28.2078 11.3752 28.4937C11.5157 28.6535 11.6888 28.7814 11.8829 28.8687C12.0769 28.956 12.2874 29.0008 12.5002 29H17.0002C17.1991 29 17.3899 28.921 17.5305 28.7803C17.6712 28.6397 17.7502 28.4489 17.7502 28.25V23.75C17.7502 23.5511 17.8292 23.3603 17.9699 23.2197C18.1105 23.079 18.3013 23 18.5002 23H21.5002C21.6991 23 21.8899 23.079 22.0305 23.2197C22.1712 23.3603 22.2502 23.5511 22.2502 23.75V28.25C22.2502 28.4489 22.3292 28.6397 22.4699 28.7803C22.6105 28.921 22.8013 29 23.0002 29H27.5002C27.749 29.0022 27.9942 28.9409 28.2127 28.8219C28.4504 28.6924 28.649 28.5014 28.7875 28.2688C28.9261 28.0362 28.9995 27.7707 29.0002 27.5V18.8281C29.0001 18.62 28.9568 18.4142 28.8728 18.2237C28.7889 18.0333 28.6663 17.8624 28.5127 17.7219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.d60cece17d5993e35af217c9d0c996cd.svg";
export { ForwardRef as ReactComponent };